import styled from 'styled-components';
import colors from '../../../assets/style/colors';

const ErrorModalStyle = styled.div`
  .card {
    background-color: #ffffff;
    text-align: center;
    display: flex;
    flex-wrap: wrap;
    .cardTop {
      width: 100%;
    }
    .cardBottom {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: flex-end;
      margin-top: 20px;
    }
    .img {
      width: 100px;
      object-fit: cover;
    }
    .title {
      margin: 0;
      padding: 0;
      font-size: 18px;
      color: #6d6d6d;
      font-weight: 600;
      margin-top: 10px;
    }
    .mainTitle {
      margin: 0;
      padding: 0;
      font-size: 30px;
      color: #171717;
      font-weight: bold;
    }
    .centerCard {
      display: flex;
      justify-content: center;
      padding: 0 50px;
    }
    .btnN {
      padding: 10px 30px;
      border-radius: 5px;
      border: 3px solid #d40000;
      background-color: #d40000;
      color: #ffffff;
      transition: 0.2s;
      font-weight: 600;
      font-size: 17px;
      cursor: pointer;
    }
    .btnN:hover {
      box-shadow: 3px 5px 15px #e2e2e2;
    }
  }
`;
export default ErrorModalStyle;
